<template>
<div class="print-sheet">
  <div class="shipping-label-page" dir="rtl">

    <div class="shipping-label">

      <!-- سربرگ -->
      <div class="label-head">
        <div class="label-insurance">
          <b>ارزش بیمه مرسوله</b>
          <div class="insurance-amount" dir="ltr">
            <small>تومان</small>
            <span>{{ insuranceAmount || '\u00A0' }}</span>
          </div>
        </div>

        <div class="label-meta">
          <strong>{{ sender }}</strong>

          <span>
              <!-- سفارش {{ orderNumber }} -->
              <template v-if="orderDate">
                — {{ orderDate }}
              </template>
            </span>
        </div>
      </div>

      <!-- گیرنده -->
      <div class="label-receiver">
        <div class="receiver-head">
          <span class="label-tag">گیرنده</span>

          <span class="shipping-method">
              <b>ارسال</b>
              {{ shippingMethod }}
            </span>
        </div>

        <div class="receiver-name">
          <span>{{ receiverTitle }}</span>

          <em v-if="data.mobile" dir="ltr">
          {{ data.mobile }}
          </em>
        </div>

        <div class="receiver-place">
          <span v-if="receiverCity" class="receiver-city">
          {{ receiverCity }}
          </span>

          <div v-if="data.zip_code" class="receiver-postal">
            <b>کد پستی</b>
            <i dir="ltr">{{ data.zip_code }}</i>
          </div>
        </div>

        <div v-if="data.address" class="receiver-address">
          {{ data.address }}
        </div>
      </div>

      <!-- فرستنده -->
      <div class="label-sender">
        <div class="sender-row">
          <span class="sender-label">فرستنده</span>

          <b>{{ sender }}</b>

          <em v-if="senderPhone" dir="ltr">
          {{ senderPhone }}
          </em>

          <em v-if="senderPhone2" dir="ltr">
          {{ senderPhone2 }}
          </em>

          <span v-if="nationalId" class="sender-national-id">
              کد ملی
              <em dir="ltr">{{ nationalId }}</em>
            </span>
        </div>

        <div class="sender-row">
          <span class="sender-label">آدرس</span>
          <span>{{ senderAddress }}</span>
        </div>
      </div>

    </div>

    <!-- خط برش -->
    <div class="label-cut">
      <span>محل برش</span>
    </div>

  </div>
</div>
</template>

<script>
export default {
  name: "PrintShippingLabel",

  props: {
    data: {
      type: Object,
      required: true
    },

    insuranceAmount: {
      type: [String, Number],
      default: "       "
    },

    orderNumber: {
      type: [String, Number],
      default: ""
    },

    orderDate: {
      type: String,
      default: ""
    },

    shippingMethod: {
      type: String,
      default: "چاپار"
    },

    sender: {
      type: String,
      default: "قاسمی"
    },

    senderPhone: {
      type: String,
      default: "۰۵۱۳۳۶۴۱۹۸۶"
    },

    senderPhone2: {
      type: String,
      default: "۰۹۹۸۱۴۵۰۶۱۵"
    },

    senderAddress: {
      type: String,
      default: "مشهد، بازار امام رضا، بازار چهارم از طرف فلکه آب، طبقه بالا پلاک ۲/۶۰۵"
    },

    nationalId: {
      type: String,
      default: "۰۹۳۶۹۴۱۳۶۷"
    }
  },

  computed: {
    receiverTitle() {
      const {
        gender,
        type,
        name
      } = this.data

      let title = name || ""

      if (gender) {
        title = `آقای ${title}`
      } else if (type === "person") {
        title = `خانم ${title}`
      }

      return title
    },

    receiverCity() {
      const province = this.data.province || ""
      const city = this.data.city || ""

      if (province && city) {
        return `${province} - ${city}`
      }

      return province || city
    }
  }
}
</script>

<style scoped>
/* ==================================================
   تنظیمات عمومی چاپ
   کاغذ: A5 عمودی، 148 × 210 میلی‌متر
   ================================================== */

@page {
  size: A5 portrait;
  margin: 0;
}

.print-sheet {
  box-sizing: border-box;
  direction: rtl;

  width: 148mm;
  height: 210mm;

  margin: 0;
  padding: 0;

  overflow: hidden;

  color: #000;
  background: #fff;

  font-family: titr, Tahoma, sans-serif;

  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.print-sheet *,
.print-sheet *::before,
.print-sheet *::after {
  box-sizing: border-box;
}

/* ==================================================
   محدوده فرم
   عرض: تمام عرض قابل استفاده A5
   ارتفاع: 100 میلی‌متر
   حاشیه افقی: 5 میلی‌متر
   ================================================== */

.shipping-label-page {
  direction: rtl;

  width: 100%;
  height: 100mm;

  margin: 0;
  padding: 4mm 5mm;

  overflow: hidden;
}

/* کادر اصلی فرم */

.shipping-label {
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  padding: 3mm;

  border: 1.2pt solid #000;
  border-radius: 2mm;

  overflow: hidden;
}

/* ==================================================
   سربرگ
   ================================================== */

.label-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  gap: 3mm;

  padding-bottom: 2mm;
  margin-bottom: 2.5mm;

  border-bottom: 0.7pt solid #000;

  flex-shrink: 0;
}

.label-insurance {
  flex-shrink: 0;

  min-width: 42mm;

  padding: 1.5mm 2mm;

  border: 1pt solid #000;
  border-radius: 1.5mm;

  text-align: center;
}

.label-insurance>b {
  display: block;

  font-size: 8pt;
  font-weight: 600;
}

.insurance-amount {
  display: flex;
  font-size: 13pt;
  font-weight: 800;
  line-height: 1.5;

  white-space: nowrap;
}

.insurance-amount small {
  font-size: 8pt;
  font-weight: 600;
}

.label-meta {
  margin-inline-start: auto;
  padding-top: 0.5mm;

  font-size: 9pt;
  line-height: 1.8;

  text-align: left;
}

.label-meta strong {
  display: block;

  font-size: 12pt;
  font-weight: 800;
}

.label-meta span {
  color: #333;
}

/* ==================================================
   اطلاعات گیرنده
   ================================================== */

.label-receiver {
  flex: 1 1 auto;

  min-height: 0;

  overflow: hidden;
}

.receiver-head {
  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 3mm;

  margin-bottom: 2mm;
}

.label-tag {
  display: inline-block;

  padding: 1mm 3mm;

  border-radius: 1mm;

  background: #000;
  color: #fff;

  font-size: 9pt;
  font-weight: 700;
}

.shipping-method {
  flex-shrink: 0;

  padding: 1mm 2.5mm;

  border: 1pt solid #000;
  border-radius: 1mm;

  font-size: 10pt;
  font-weight: 800;
}

.shipping-method b {
  font-size: 8pt;
  font-weight: 600;
}

.receiver-name {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;

  gap: 3mm;

  font-size: 14pt;
  font-weight: 800;
  line-height: 1.6;
}

.receiver-name em {
  direction: ltr;

  font-size: 11pt;
  font-weight: 700;
  font-style: normal;
}

.receiver-place {
  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 3mm;

  min-height: 8mm;
  margin-top: 1.5mm;
}

.receiver-city {
  font-size: 11pt;
  font-weight: 800;
}

.receiver-postal {
  display: flex;
  align-items: center;

  flex-shrink: 0;

  gap: 2mm;

  padding: 1mm 2mm;

  border: 0.8pt dashed #000;
  border-radius: 1mm;
}

.receiver-postal b {
  font-size: 8pt;
  font-weight: 600;
}

.receiver-postal i {
  direction: ltr;

  font-size: 10pt;
  font-weight: 800;
  font-style: normal;

  letter-spacing: 0.5px;
}

.receiver-address {
  margin-top: 1mm;

  font-size: 10pt;
  font-weight: 600;
  line-height: 1.8;

  overflow-wrap: anywhere;
}

/* ==================================================
   اطلاعات فرستنده
   ================================================== */

.label-sender {
  flex-shrink: 0;

  margin-top: 2mm;
  padding-top: 2mm;

  border-top: 0.7pt solid #000;

  color: #1a1a1a;

  font-size: 8pt;
  line-height: 1.8;
}

.sender-row {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;

  gap: 2mm;
}

.sender-label {
  flex-shrink: 0;

  color: #444;

  font-size: 8pt;
  font-weight: 700;
}

.label-sender b {
  font-size: 10pt;
  font-weight: 800;
}

.label-sender em {
  direction: ltr;
  font-style: normal;
}

.sender-national-id {
  display: inline-flex;
  align-items: baseline;

  gap: 1.5mm;

  padding-right: 2mm;

  border-right: 0.7pt solid #999;

  color: #444;
}

.sender-national-id em {
  color: #000;
  font-weight: 700;
}

/* ==================================================
   خط برش
   ================================================== */

.label-cut {
  margin-top: 3mm;

  border-top: 1pt dashed #999;

  color: #777;

  font-size: 7pt;
  text-align: center;
}

.label-cut span {
  position: relative;
  top: -1.8mm;

  padding: 0 2mm;

  background: #fff;
}

/* ==================================================
   تنظیمات چاپ
   ================================================== */

@media print {
  .print-sheet {
    width: 148mm;
    height: 210mm;

    margin: 0;
    padding: 0;

    overflow: hidden;

    break-after: avoid-page;
    page-break-after: avoid;
  }

  .shipping-label-page {
    width: 100%;
    height: 100mm;

    margin: 0;
    padding: 4mm 5mm;

    overflow: hidden;
  }

  .shipping-label {
    height: 100%;
  }
}
</style>
